export const COLOR = 'COLOR'